var _alternateLocalesMap;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { LocaleCode } from '@tablecheck/locales';
import isObject from 'lodash/isObject';
var languagePriorities = [LocaleCode.English, LocaleCode.Japanese];
var alternateLocalesMap = (_alternateLocalesMap = {}, _defineProperty(_alternateLocalesMap, LocaleCode.ChineseSimplified, [LocaleCode.ChineseTraditional]), _defineProperty(_alternateLocalesMap, LocaleCode.ChineseTraditional, [LocaleCode.ChineseSimplified]), _alternateLocalesMap);

function handleLegacyTranslations(input) {
  return input.map(function (translation) {
    if ('translation' in translation) return translation;
    return {
      locale: translation.locale,
      translation: translation.text
    };
  });
}
/**
 * Resolves a translation based on a priority list
 */


function getTranslation(translationsParam) {
  var targetLocale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : languagePriorities[0];
  var defaultTranslation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  if (!translationsParam) return defaultTranslation;
  var translations = translationsParam;

  if (typeof translationsParam === 'string') {
    try {
      translations = JSON.parse(translationsParam);

      if (!Array.isArray(translations) && !isObject(translations)) {
        console.error("Parameter passed to getTranslation is not a valid JSON string, ".concat(translationsParam));
        return translationsParam ? translationsParam.toString() : defaultTranslation;
      }
    } catch (error) {
      return translationsParam ? translationsParam.toString() : defaultTranslation;
    }
  }

  if (!Array.isArray(translations)) {
    translations = Object.keys(translations).reduce(function (result, key) {
      var value = translations[key];
      if (!value) return result;
      return result.concat([{
        locale: key,
        translation: value
      }]);
    }, []);
  } else {
    translations = handleLegacyTranslations(translations);
  }

  if (!translations.length) return defaultTranslation;
  var identicalMatch = translations.find(function (_ref) {
    var locale = _ref.locale;
    return locale === targetLocale;
  });

  if (identicalMatch) {
    return identicalMatch.translation;
  }

  var alternateLocales = alternateLocalesMap[targetLocale];
  var foundPriorityIndex = -1;
  var bestMatch;

  for (var t = 0; t < translations.length; t += 1) {
    var _translations$t = translations[t],
        locale = _translations$t.locale,
        translation = _translations$t.translation;

    if (alternateLocales) {
      for (var a = 0; a < alternateLocales.length; a += 1) {
        if (alternateLocales[a] === locale) {
          return translation;
        }
      }
    }

    var priorityIndex = foundPriorityIndex === -1 ? languagePriorities.length : foundPriorityIndex;

    for (var p = 0; p < priorityIndex; p += 1) {
      if (locale === languagePriorities[p]) {
        foundPriorityIndex = p;
        bestMatch = translations[t];
        break;
      }
    }
  }

  return bestMatch ? bestMatch.translation : translations[0].translation;
}

export { getTranslation, handleLegacyTranslations };
